// Nguồn sự thật DUY NHẤT cho nội dung + danh sách pattern bắt buộc của `.claude/.gitignore`.
//
// Ticket #172 — vì sao tách khỏi project-tree-scaffolder.ts:
//   1. Ba consumer cần cùng danh sách: `init` (ghi đè toàn file), `sync` (append pattern thiếu),
//      `doctor` (dò pattern thiếu). Để hằng ở scaffolder thì 2 consumer sau phải nhân bản literal.
//   2. scaffolder import `template-bundle-loader.js` (side-effect) — chính lý do doctor.ts phải
//      `await import()` động. Module này 0 import ⇒ static-import được từ mọi nơi.
//
// BẤT BIẾN: `CLAUDE_GITIGNORE_REQUIRED_PATTERNS` phải DERIVE từ `CLAUDE_GITIGNORE_CONTENT`.
// ⛔ CẤM khai lại thành mảng literal: thêm dòng vào content mà quên mảng ⇒ `sync` và `doctor`
//    mù với pattern mới, đúng lớp lỗi mà #172 sinh ra để đóng.

// Dời từ project-tree-scaffolder.ts:197-210 — verbatim MỘT NGOẠI LỆ: thêm pattern avatar-backup
// (dòng thứ 3 trong template dưới) ngay dưới `settings.json.backup-*` (R1b / D9).
// ⛔ KHÔNG chép danh sách pattern (kể cả dạng "bản đọc nhanh") và KHÔNG viết SỐ LƯỢNG pattern vào
//    bất kỳ comment nào của file này: đó là bản sao thứ hai của bảng số — thêm dòng vào template
//    là comment thành sai sự thật mà không gate nào bắt (đúng lớp lỗi #161). Danh sách và số
//    lượng chỉ đọc ở một chỗ: hằng CLAUDE_GITIGNORE_CONTENT ngay dưới đây.
//
// ⛔ KHÔNG dán nguyên văn chuỗi pattern avatar-backup (kèm dấu sao) vào BẤT KỲ comment nào của
//    file này. Gate #172 đo `grep -Fc '<chuỗi đó>' <file này>` = 1 để chứng minh nó được khai
//    ĐÚNG MỘT LẦN; mỗi lần trích lại trong comment là gate mất khả năng bắt khai trùng.
export const CLAUDE_GITIGNORE_CONTENT = `# Avatar — bảo vệ file nhạy cảm trong .claude/.
# Workspace root KHÔNG git; file này phòng trường hợp .claude/ bị track nhầm.
settings.json
settings.json.backup-*
# #172: backupIfExists (project-tree-scaffolder.ts:25) ghi ra settings.json.avatar-backup-<ts> =
# bản sao NGUYÊN VĂN settings.json (chứa API key), SỐNG LÂU DÀI (khác lock file sub-second).
# Dòng settings.json.backup-* ở trên KHÔNG khớp nó (thiếu "avatar-") ⇒ phải có dòng riêng.
settings.json.avatar-backup-*
# #164: lock file của withSettingsFileLock. PHẢI có dấu sao — chốt (b2) còn đẻ
# settings.json.lock.stealing-<uid>, mà pattern trần không khớp file đó (y như
# dòng settings.json sẵn có không khớp settings.json.backup-*).
settings.json.lock*
# #189: backupDirBeforeReplace (backup-existing-dir-before-symlink-override.ts) đổi tên THƯ MỤC
# thật thành <tên>.backup-<YYYY-MM-DD-HHMM>; các mục settings.json.* ở trên không khớp thư mục đó.
*.backup-[0-9][0-9][0-9][0-9]-*
.env
.env.*
_pending/
_backup/
state/session-*.json
`;

// Dòng "là pattern" = sau khi bỏ khoảng trắng CUỐI dòng còn ký tự và không mở đầu bằng '#'.
// `\r` của file CRLF (Windows member) rụng ở bước replace — không cần detector line-ending.
//
// ⛔ trimEnd, KHÔNG trim. Git chỉ bỏ khoảng trắng CUỐI dòng; khoảng trắng ĐẦU dòng là MỘT PHẦN
//    của pattern (dòng thụt lề chỉ khớp tên file cũng thụt lề — tức là không khớp gì). Dùng trim()
//    ở đây thì dòng thụt lề bị tính là "pattern đã có" ⇒ doctor in đủ, sync no-op, trong khi git
//    KHÔNG ignore file nhạy cảm: cổng bảo mật báo XANH SAI. Đo thật bằng `git check-ignore` trên
//    repo git dựng tạm — xem reports/phase-06-code-review-fixes.md §probe.
export function parseGitignorePatterns(text: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of text.split("\n")) {
    const line = raw.replace(/\r$/, "").trimEnd();
    if (line === "" || line.startsWith("#")) continue;
    if (seen.has(line)) continue;
    seen.add(line);
    out.push(line);
  }
  return out;
}

export const CLAUDE_GITIGNORE_REQUIRED_PATTERNS: readonly string[] =
  parseGitignorePatterns(CLAUDE_GITIGNORE_CONTENT);

// So khớp EXACT trên dòng đã trim. KHÔNG prefix/substring/glob-subsumption:
// `settings.json.lock` trần KHÔNG được coi là phủ `settings.json.lock*` — chốt (b2) của #164 còn
// đẻ `settings.json.lock.stealing-<uid>`, mà pattern trần không khớp file đó. Nới thành
// startsWith là mở lại đúng lỗ #164 và không cơ chế nào phát hiện.
export function findMissingClaudeGitignorePatterns(existing: string): string[] {
  const present = new Set(parseGitignorePatterns(existing));
  return CLAUDE_GITIGNORE_REQUIRED_PATTERNS.filter((p) => !present.has(p));
}
